<template>
  <div class="email-recipient">
    <div class="email-recipient__top">
      <div class="email-recipient__left">
        <div class="email-recipient__id">
          <template v-if="count > 0">{{ count }}.</template> {{ data.email_template.sendpulse_template.name }}
        </div>
        <div class="email-recipient__tower">
          <div v-if="data.sendpulse_log" class="email-recipient__name-wrapper">
            <div class="email-recipient__time">
              <div class="email-recipient__time-text">Subject:</div>
              <div class="email-recipient__time-value">{{ data.sendpulse_log.subject }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="email-recipient__right"></div>
    </div>
    <button @click="is_open = !is_open" type="button" class="email-recipient__button">
      <span class="email-recipient__status-block">
        <span
          v-tooltip="{ content: data.created_by.full_name || '', placement: 'right', offset: 10 }"
          class="email-recipient__photo"
        >
          <img :src="getUserAvatar(data.created_by.crop.crop_url)" alt="Avatar">
        </span>
        <span v-if="data.sendpulse_log" class="email-recipient__time">
          <span class="email-recipient__name">
            {{ formatDateTime(data.sendpulse_log.created_at) }}
          </span>
        </span>
      </span>
      <span v-if="data.sendpulse_log" class="email-recipient__indicators">
        <span class="email-recipient__indicator">
          <span>Delivered</span>
          <span
            class="status-title"
            :style="{ 'backgroundColor': data.sendpulse_log.recipients_delivered === 0 ? '#f36161' : data.sendpulse_log.recipients_delivered === data.sendpulse_log.recipients.length ? '#77b017' : '#f0c427' }"
          >
            {{ data.sendpulse_log.recipients.length }} / {{ data.sendpulse_log.recipients_delivered }}
          </span>
        </span>
        <span class="email-recipient__indicator">
          <span> Read</span>
          <span
            class="status-title"
            :style="{ 'backgroundColor': data.sendpulse_log.recipients_read === 0 ? '#f36161' : data.sendpulse_log.recipients_read === data.sendpulse_log.recipients.length ? '#77b017' : '#f0c427' }"
          >
            {{ data.sendpulse_log.recipients.length }} / {{ data.sendpulse_log.recipients_read }}
          </span>
        </span>
      </span>
      <span class="email-recipient__toggler" :class="{ 'email-recipient__toggler--open': is_open }">
        <img src="@/assets/img/arrow-toggler-bottom-icon.svg" alt="">
      </span>
    </button>
    <transition name="slide-block">
      <div v-if="is_open" class="email-recipient__dropdown">
        <div class="email-recipient__list">
          <div class="transport-list">
            <div class="transport-list__header">
              <div class="transport-list__row">
                <div class="transport-list__col">Recipient</div>
                <div class="transport-list__col transport-list__col--center">Delivered</div>
                <div class="transport-list__col transport-list__col--center">Delivered at</div>
                <div class="transport-list__col transport-list__col--center">Opened</div>
                <div class="transport-list__col transport-list__col--center">Opened at</div>
              </div>
            </div>
            <div class="transport-list__body">
              <div v-if="data.sendpulse_log.recipients.length" class="transport-list__part">
                <div v-for="(item, index) in data.sendpulse_log.recipients" :key="`own_${item.id}`" class="transport-list__row">
                  <div class="transport-list__col">
                    {{ index + 1 }}. {{ item.recipient }}
                  </div>
                  <div class="transport-list__col transport-list__col--center">
                    <div class="status-title" :style="{ 'backgroundColor': item.delivered ? '#77b017' : '#f36161' }">
                      {{ item.delivered ? 'Yes' : 'No' }}
                    </div>
                  </div>
                  <div class="transport-list__col transport-list__col--center">
                    {{ formatDateTime(item.delivered_at) }}
                  </div>
                  <div class="transport-list__col transport-list__col--center">
                    <div class="status-title" :style="{ 'backgroundColor': item.opened ? '#77b017' : '#f36161' }">
                      {{ item.opened ? 'Yes' : 'No' }}
                    </div>
                  </div>
                  <div class="transport-list__col transport-list__col--center">
                    {{ formatDateTime(item.opened_at) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { format, parse, parseISO } from 'date-fns'

export default {
  name: 'AppEmailListMultipleRecipient',
  props: {
    data: Object,
    count: Number,
  },
  data() {
    return {
      is_open: false,
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
  },
  methods: {
    onPatchReservation(id, data) {
      this.$emit('onPatchReservation', id, data)
    },
    onRequestCancellation(data) {
      this.$emit('onRequestCancellation', data)
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    formatDateTime(date) {
      if (!date) return '-'
      return format(parseISO(date), 'dd MMMM yyyy HH:mm')
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>

<style lang="sass" scoped>
// ------------------------ email-recipient
.email-recipient
  margin-bottom: 10px
  border: 1px solid #dfdfdf
  border-radius: 10px
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08)
  background-color: #fff
  overflow: hidden

.email-recipient__top
  display: flex
  align-items: center
  justify-content: space-between
  padding: 7px 16px
  border-bottom: 1px solid #e8e8e8

.email-recipient__left
  display: grid
  grid-template-columns: 300px max-content
  align-items: center
  gap: 20px

.email-recipient__indicators
  display: flex
  align-items: center
  gap: 10px
  width: 232px

.email-recipient__indicator
  display: flex
  align-items: center
  gap: 6px

.email-recipient__id
  font-weight: 500

.email-recipient__photo
  width: 31px
  line-height: 0
  border-radius: 50%
  overflow: hidden

.email-recipient__name-wrapper
  display: flex
  gap: 10px
  margin-bottom: 6px

.email-recipient__name
  font-weight: 500

.email-recipient__button
  position: relative
  display: grid
  grid-template-columns: 300px max-content
  align-items: center
  gap: 20px
  width: 100%
  padding: 10px 16px
  cursor: pointer
  text-align: left

.email-recipient__status-block
  display: inline-flex
  align-items: center
  gap: 12px

.email-recipient__status
  display: inline-block
  min-width: 110px
  padding: 4px 8px 5px
  border-radius: 20px
  color: #fff
  font-size: 13px
  font-weight: 600
  text-align: center

.email-recipient__time
  display: flex
  gap: 6px

.email-recipient__time-text
  color: #5f5f5f

.email-recipient__time-value
  color: #181818
  font-weight: 500

.email-recipient__toggler
  position: absolute
  top: 14px
  right: 18px
  transition: transform 0.3s

.email-recipient__toggler--open
  transform: rotate(180deg)

.email-recipient__dropdown
  border-top: 1px solid #e8e8e8
  background-color: #fafafa

.email-recipient__list
  padding: 14px

.email-recipient__right
  display: flex
  align-items: center
  gap: 10px

// ------------------------ slide-block
.slide-block-enter-active
  transition-duration: 0.3s
  transition-timing-function: ease-in

.slide-block-leave-active
  transition-duration: 0.3s
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1)

.slide-block-enter-to, .slide-block-leave
  max-height: 500px
  overflow: hidden

.slide-block-enter, .slide-block-leave-to
  overflow: hidden
  max-height: 0

// ------------------------ transport-list
.transport-list
  border-top: 1px solid #e8e8e8

.transport-list__part
  border-bottom: 1px solid #e8e8e8

  &:last-child
    border-bottom: none

.transport-list__header
  border-bottom: 1px solid #e8e8e8

  .transport-list__row
    padding: 10px 20px

  .transport-list__col
    font-weight: 500

.transport-list__body
  .transport-list__col
    font-size: 13px
    font-weight: 500

.transport-list__row
  display: grid
  grid-template-columns: 320px repeat(4, 1fr)
  gap: 15px
  align-items: center
  padding: 5px 20px

.transport-list__confirmed
  width: 20px

.transport-list__col--lh0
  line-height: 0

.transport-list__col--center
  text-align: center
  margin: 0 auto

.transport-list__col--flex
  display: flex
  align-items: center
  gap: 6px

.transport-list__name
  padding: 10px 20px 0 20px
  color: #5e5e5e
  font-size: 13px

.transport-list__socials
  display: inline-flex
  gap: 10px
  line-height: 0

  a, button
    display: inline-block
    line-height: 0
    transition: transform 0.3s

    &.grayscale
      pointer-events: none

    &:hover
      transform: translateY(-2px)

.transport-list__status
  display: inline-flex
  gap: 10px
  line-height: 0

</style>